import React, { FC, ReactNode } from 'react';

import { isAuthenticated } from 'helpers/auth';

import { AuthServiceContext } from 'modules/authService/context';
import { AuthService } from 'modules/authService/service';

import { setAuthService } from 'services/authService';

export const AuthServiceProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const authService = new AuthService(isAuthenticated());

  // makes auth service accessible for non react tree code
  setAuthService(authService);

  return (
    <AuthServiceContext.Provider value={authService}>
      {children}
    </AuthServiceContext.Provider>
  );
};
